// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ded0b2c1","637":"46b4c1d4"}[chunkId] + ".chunk.js";
};